var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"noData"},[_c('div',{staticClass:"js-loading"},[_c('div',{staticClass:"js-noData"},[_c('img',{attrs:{"alt":"暂无活动","src":"https://staticn.jinse.cn/w/img/7007794.svg"}}),_c('span',[_vm._v("暂无数据")])])])])
}]

export { render, staticRenderFns }